import PropTypes from 'prop-types';

export const FusionPropTypes = {
  data: PropTypes.any,
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  field: PropTypes.shape({
    help_text: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    widget: PropTypes.shape({
      attrs: PropTypes.shape({
        hideLabel: PropTypes.bool,
        placeholder: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

export const FusionSelectPropTypes = {
  ...FusionPropTypes,
  field: PropTypes.shape({
    help_text: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    widget: PropTypes.shape({
      attrs: PropTypes.shape({
        hideLabel: PropTypes.bool,
        placeholder: PropTypes.string,
      }).isRequired,
      choices: PropTypes.arrayOf(
        PropTypes.shape({
          display: PropTypes.string.isRequired,
          value: PropTypes.any.isRequired,
        }),
      ).isRequired,
    }).isRequired,
  }).isRequired,
};
